/**
 * Variable name for Data Pre-fetcher result in the window object
 */ export const DataPreFetcherResultVarName = "dataPreFetcherResult";
/**
 * Variable name for Data Pre-fetcher completed status in the window object
 */ export const DataPreFetchCompletedVarName = "dataPreFetchCompleted";
/**
 * Variable name for Data Pre-fetcher skipped status in the window object
 */ export const DataPreFetchSkippedVarName = "dataPreFetchSkipped";
/**
 * Variable name for Data Pre-fetcher failed status for current view in the window object
 */ export const DataPreFetchFailureStatusForView = "dataPreFetchFailedForView";
/**
 * Variable name for Data Pre-fetcher failed status for mru in the window object
 */ export const DataPreFetchFailureStatusForMru = "dataPreFetchFailedForMru";
/**
 * Variable name for Data Pre-fetcher view name in the window object
 */ export const DataPrefetchViewName = "dataPreFetchViewName";
/**
 * Variable name for Data Pre-fetcher view id in the window object
 */ export const DataPrefetchViewId = "dataPreFetchViewId";
/**
 * Data Pre-fetcher event names
 */ export var DataPreFetcherEventNames = /*#__PURE__*/ function(DataPreFetcherEventNames) {
    /**
     * Event name for Data Pre-fetcher completion
     */ DataPreFetcherEventNames["FetchCompleted"] = "DataPreFetchCompleted";
    /**
     * Event name for Data Pre-fetcher skipped status
     */ DataPreFetcherEventNames["FetchSkipped"] = "DataPreFetchSkipped";
    /**
     * Event name for Data Pre-fetcher Mru data fetched
     */ DataPreFetcherEventNames["FetchedMruData"] = "DataPreFetcherMruDataFetched";
    /**
     * Event name for Data Pre-fetcher MyDay tasks fetched
     */ DataPreFetcherEventNames["FetchedMyDayTasks"] = "DataPreFetcherMyDayTasksFetched";
    /**
     * Event name for Data Pre-fetcher ATM tasks fetched
     */ DataPreFetcherEventNames["FetchedATMTasks"] = "DataPreFetcherATMTasksFetched";
    /**
     * Event name for Data Pre-fetcher Plan fetched
     */ DataPreFetcherEventNames["FetchedPlan"] = "DataPreFetcherPlanFetched";
    /**
     * Event name for Data Pre-fetcher TeamsTasksTabs fetched
     */ DataPreFetcherEventNames["FetchedTTTabs"] = "DataPreFetcherTTTabsFetched";
    /**
     * Event name for Data Pre-fetcher Buckets fetched
     */ DataPreFetcherEventNames["FetchedBuckets"] = "DataPreFetcherBucketsFetched";
    /**
     * Event name for Data Pre-fetcher TodoSettings fetched
     */ DataPreFetcherEventNames["FetchedTodoSettings"] = "DataPreFetcherTodoSettingsFetched";
    /**
     * Event name for Data Pre-fetcher BasicPlanTasks fetched
     */ DataPreFetcherEventNames["FetchedBasicPlanTasks"] = "DataPreFetcherBasicPlanTasksFetched";
    return DataPreFetcherEventNames;
}({});
/**
 * Keys of pre-fetched data
 */ export var PreFetchedDataKeys = /*#__PURE__*/ function(PreFetchedDataKeys) {
    /**
     * Mru data key
     */ PreFetchedDataKeys["Mru"] = "mru";
    /**
     * MyDay tasks data key
     */ PreFetchedDataKeys["MyDayTasks"] = "myDayTasks";
    /**
     * ATM tasks data key
     */ PreFetchedDataKeys["ATMTasks"] = "atmTasks";
    /**
     * Plan data key
     */ PreFetchedDataKeys["Plan"] = "plan";
    /**
     * TeamsTasksTabs data key
     */ PreFetchedDataKeys["TTTabs"] = "ttTabs";
    /**
     * Plan buckets data key
     */ PreFetchedDataKeys["Buckets"] = "buckets";
    /**
     * Todo settings data key
     */ PreFetchedDataKeys["TodoSettings"] = "todoSettings";
    /**
     * Basic plan tasks data key
     */ PreFetchedDataKeys["BasicPlanTasks"] = "basicPlanTasks";
    return PreFetchedDataKeys;
}({});
